export default "__VITE_ASSET__KrpKgpPM__"